module.exports = __webpack_public_path__ + "assets/img/logo-saules-bendruomene.f2a5ab75.webp";